import { BUFF_CAP } from '../data/balance';
import type { Buff, CountBuff } from './types';

/**
 * Stacking buffs. Overlapping buffs in the same stream multiply, but the
 * product is capped at BUFF_CAP so chained events can't compound without
 * bound (the v0.9 $8×10^171 save).
 */
export function addBuff(stack: Buff[], mult: number, durationMs: number, now: number, source: string): void {
  stack.push({ mult, until: now + durationMs, source });
}

export function pruneBuffs(stack: Buff[], now: number): void {
  for (let i = stack.length - 1; i >= 0; i--) if (stack[i]!.until <= now) stack.splice(i, 1);
}

export function buffProduct(stack: readonly Buff[], now: number): number {
  let m = 1;
  for (const b of stack) if (b.until > now) m *= b.mult;
  return Math.min(BUFF_CAP, m);
}

export function buffRemainingMs(stack: readonly Buff[], now: number): number {
  let latest = 0;
  for (const b of stack) if (b.until > latest) latest = b.until;
  return Math.max(0, latest - now);
}

export function clutchProduct(stack: readonly CountBuff[]): number {
  let m = 1;
  for (const b of stack) if (b.remaining > 0) m *= b.mult;
  return Math.min(BUFF_CAP, m);
}

/** Consumes one charge from every active count buff (one collected egg). */
export function consumeClutch(stack: CountBuff[], eggs: number): void {
  for (const b of stack) b.remaining = Math.max(0, b.remaining - eggs);
  for (let i = stack.length - 1; i >= 0; i--) if (stack[i]!.remaining <= 0) stack.splice(i, 1);
}
